import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
	output,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { CourseGAService } from '@uc/web/analytics';
import { CourseSearchLocationGAEnum } from '@uc/web/shared/data-models';

@Component({
	selector: 'uc-related-subject',
	templateUrl: './related-subject.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [RouterLink, CommonModule],
})
export class RelatedSubjectComponent {
	label = input.required<string>();
	degreeLevel = input<string>();
	count = input<number>();

	relatedSubject = output<string>();

	link = computed(() => {
		const subject = this._formatSubject();

		const pathSegments =
			this.degreeLevel() === 'clearing'
				? ['clearing', subject]
				: ['degrees', this.degreeLevel(), subject];

		const segments = [...new Set(['/courses', ...pathSegments])].filter(Boolean);

		return segments.join('/');
	});

	private _courseGAService = inject(CourseGAService);

	onRelatedSubject() {
		this._courseGAService.setSearchLocation(
			CourseSearchLocationGAEnum.RelatedSubjects,
		);
		const subject = this._formatSubject();
		this.relatedSubject.emit(subject);
	}

	private _formatSubject() {
		return this.label()?.toLowerCase().replace(/['"]/g, '').replace(/\s+/g, '-');
	}
}
